import { ActionIcon, Group, Text, type TextProps } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import { IconCheck, IconCopy } from '@tabler/icons-react';

const SIZE_MAP = {
  xs: 8,
  sm: 14,
  md: 20,
  lg: 24,
  xl: 30,
} as const;

export function CopyText({
  children,
  ...textProps
}: TextProps & { children: string }) {
  const clipboard = useClipboard({ timeout: 1500 });

  const size = SIZE_MAP?.[textProps.size as keyof typeof SIZE_MAP] ?? 12;
  return (
    <Group gap={4} wrap="nowrap">
      <Text {...textProps}>{children}</Text>
      <ActionIcon
        variant="subtle"
        size="xs"
        color={clipboard.copied ? 'green' : 'gray'}
        onClick={() => clipboard.copy(children)}
      >
        {clipboard.copied ? (
          <IconCheck size={size} />
        ) : (
          <IconCopy size={size} />
        )}
      </ActionIcon>
    </Group>
  );
}
